import React, { useState } from 'react';
import LanguageContext from './contexts/LanguageContext';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Features from './components/Features';
import Lifestyle from './components/Lifestyle';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import WhyUs from './components/WhyUs';
import Business from './components/Business';
import Service from './components/Service';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('pl');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <SEOHead />
      <div className="App min-h-screen flex flex-col">
        <Header />
        <Hero />
        <Problem />
        <Solution />
        <Features />
        <Lifestyle />
        <HowItWorks />
        <Benefits />
        <WhyUs />
        <Business />
        <Service />
        <CTA />
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
